export const allowNext = (current: number, pages: number): boolean => current + 1 <= pages;
export const allowPrev = (current: number, pages: number): boolean => current - 1 >= 1;
